/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface BaseTrustDetailsViewModel
 */
export interface BaseTrustDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof BaseTrustDetailsViewModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseTrustDetailsViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof BaseTrustDetailsViewModel
     */
    areAllBeneficiariesIndividuals: IAPYESORNO;
    /**
     * 
     * @type {string}
     * @memberof BaseTrustDetailsViewModel
     */
    popiaStatus?: string;
}

/**
 * Check if a given object implements the BaseTrustDetailsViewModel interface.
 */
export function instanceOfBaseTrustDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "areAllBeneficiariesIndividuals" in value;

    return isInstance;
}

export function BaseTrustDetailsViewModelFromJSON(json: any): BaseTrustDetailsViewModel {
    return BaseTrustDetailsViewModelFromJSONTyped(json, false);
}

export function BaseTrustDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseTrustDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['Name'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'areAllBeneficiariesIndividuals': IAPYESORNOFromJSON(json['AreAllBeneficiariesIndividuals']),
        'popiaStatus': !exists(json, 'PopiaStatus') ? undefined : json['PopiaStatus'],
    };
}

export function BaseTrustDetailsViewModelToJSON(value?: BaseTrustDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Name': value.name,
        'RegistrationNumber': value.registrationNumber,
        'AreAllBeneficiariesIndividuals': IAPYESORNOToJSON(value.areAllBeneficiariesIndividuals),
        'PopiaStatus': value.popiaStatus,
    };
}

